import React from 'react';

const Title=()=>{
    return <h1>Welcome</h1>
}

export default Title;